export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/fission/catcher' */ './Catcher'
  );
